import { render, staticRenderFns } from "./teamtaskTest.vue?vue&type=template&id=1e485c89"
import script from "./teamtaskTest.vue?vue&type=script&lang=js"
export * from "./teamtaskTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports